import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class SystemRoleAPI extends DIApi {
  controllerName = 'SystemRoles';

  /**
   * Lấy dữ liệu danh sách vai trò
   * ncquyen 2.12.2022
   */
  getRolePaging(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetRolePaging',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * cập nhật quyền
   * @param {*} payload
   * TTLONG 01/12/2022
   */

  async updateRole(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/UpdateRole',
      data: payload,
    };

    return await httpClient.putAsync(request);
  }

  /**
   * Lấy quyền mới theo UserID
   * @param {*} payload
   * ldduy (8.1.2024)
   */
  getRole(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetPermission' + '/' + payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * kiểm tra phát sinh dữ liệu
   * @param {} payload
   * @returns
   * tvhien 06.06.2023
   */
  checkReferenceData(payload) {
    let request = {
      url: this.getAPIUrl() + '/CheckReferenceData',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy thôgn tin các vai trò người dùng đảm nhận
   * @param {*} param
   * @returns
   * dtnga3 (13.06.2023)
   */
  async getRoleOfUserInDatabase(param) {
    let request = {
      url: this.getAPIUrl() + '/GetRoleOfUserInDatabase',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new SystemRoleAPI();
